export enum CommunicationMode {
    PHONE = "phone",
    SMS = "sms",
    EMAIL = "email"
}